import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMask from 'v-mask';
import VueRouter from 'vue-router';
import vco from 'v-click-outside';
import router from './router/index';
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';
import store from '@/state/store';
import App from './App.vue';
import i18n from './i18n';
import MsalBrowserUtil from '@/utils/msalBrowserUtil';

import '@/design/index.scss';
import './assets/css/global.css';

import tinymce from 'vue-tinymce-editor';
Vue.component('tinymce', tinymce);

const moment = require('moment');
require('moment/locale/en-ca');
require('moment/locale/fr-ca');
require('moment/locale/fr');

let redirectUrl = process.env.VUE_APP_REDIRECT_URL;

let msalBrowserUtil = new MsalBrowserUtil(redirectUrl);
//msalBrowserUtil.init();
Vue.prototype.$msal = msalBrowserUtil;

let config = {
  baseURL: process.env.VUE_APP_API_URL,
};
let verifTokenExpiration = async (config) => {
  //verif expiration
  let currentAccount = Vue.prototype.$msal.currentAccount;
  if (currentAccount != null) {
    const token = await Vue.prototype.$msal.getToken();
    if (token) {
      Object.assign(config, {
        headers: { authorization: 'Bearer ' + token },
      });
    }
    return config;
  }
};

let axiosMainClient = axios.create(config);
axiosMainClient.interceptors.request.use(verifTokenExpiration, (error) =>
  Promise.reject(error)
);

axiosMainClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response != undefined && error.response.status === 403) {
      router.replace('/403');
    }
    return Promise.reject(error);
  }
);
Vue.prototype.$axiosMainClient = axiosMainClient;

Vue.use(VueRouter);

Vue.use(require('vue-moment'), {
  moment,
});

Vue.use(require('vue-moment'));

Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require('vue-chartist'));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true,
});
Vue.component('apexchart', VueApexCharts);

import ToastUtil from './utils/toastUtil';

let toastClass = new ToastUtil();
//msalBrowserUtil.init();
Vue.prototype.$toast = toastClass;

Vue.mixin({
  methods: {
    toFloat(x) {
      return parseFloat(Number(x).toFixed(5));
    },
    multiselectClosed(ms) {
      ms.deactivate();
    },
    addHttps(link) {
      if (link === null || link.length < 0) {
        return '';
      }

      return link.startsWith('http://') || link.startsWith('https://')
        ? link
        : `https://${link}`;
    },
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
